import { configureStore } from "@reduxjs/toolkit";
import adNetworkReducer from "./adNetworkReducer";
import appReducer from "./appReducer";
import countryReducer from "./countryReducer";

const store = configureStore({
  reducer: {
    adNetwork: adNetworkReducer,
    countries: countryReducer,
    app: appReducer,
  },
});

export default store;
